import type { ReactNode } from "react";
import "./FlatSelectItem.scss";
import classNames from "classnames";

interface Properties {
  label: string;
  selected: boolean;
  onSelect: () => void;
}

export default function FlatSelectItem(props: Properties): ReactNode {
  return (
    <div
      className={classNames("flat-select-item", props.selected && "selected")}
      onClick={props.onSelect}
    >
      <div>{props.label}</div>
      <div className={"check-icon"} />
    </div>
  );
}
